export const REQUEST = 'EVENTS/REQUEST';
export const RECEIVE = 'EVENTS/RECEIVE';